import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ThunkApiType } from '@/store';
import type { DefecationJson } from '@/types/domain/defecation/entities/defecationEntity';

import { defecationSlice } from '@/domain/defecation/redux';
import { service } from '@/share';

export const refreshDefecationList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'defecation/refreshDefecationList',
  async (_, thunkApi) => {
    const result: {
      items: DefecationJson[],
      nextToken: string,
    } = await service.defecation.getDefecationList(null);
    thunkApi.dispatch(defecationSlice.actions.setDefecationList(result));
  },
);

export const getDefecationList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'defecation/getDefecationList',
  async (_, thunkApi) => {
    const { nextToken, defecationList } = thunkApi.getState().defecation;
    if (!nextToken) {
      if (defecationList.length === 0) {
        thunkApi.dispatch(refreshDefecationList());
      }
      return;
    }
    const result: {
      items: DefecationJson[],
      nextToken: string,
    } = await service.defecation.getDefecationList(nextToken);
    const newList = defecationList.map((v) => v);
    for (let i = 0; i < result.items.length; i += 1) {
      newList.push(result.items[i]);
    }
    thunkApi.dispatch(defecationSlice.actions.setDefecationList({
      items: newList,
      nextToken: result.nextToken,
    }));
  },
);

export const createDefecation = createAsyncThunk<
  void,
  {
    /** データ */
    data: DefecationJson,
    /** 施設IDリスト */
    facilityIds: string[],
  },
  ThunkApiType
>(
  'defecation/create',
  async (input, _thunkApi) => {
    await service.defecation.createDefecation(input.data);
    if (input.facilityIds.length > 0) {
      const promises = input.facilityIds.map(
        (v) => service.defecationNursery.sendNurseryDefecation({
          data: input.data.data,
          pub: {
            sendId: input.data.pub.sendId,
            replyId: v,
            data: { ...input.data.pub.data },
          },
        }),
      );
      await Promise.all(promises);
    }
  },
);

export const deleteDefecation = createAsyncThunk<
  void,
  {
    /** データ */
    data: DefecationJson,
    /** 施設IDリスト */
    facilityIds: string[],
  },
  ThunkApiType
>(
  'defecation/delete',
  async (input, _thunkApi) => {
    await service.defecation.deleteDefecation(input.data);
    if (input.facilityIds.length > 0) {
      const promises = input.facilityIds.map(
        (v) => service.defecationNursery.removeNurseryDefecation({
          data: input.data.data,
          pub: {
            sendId: input.data.pub.sendId,
            replyId: v,
            data: { ...input.data.pub.data },
          },
        }),
      );
      await Promise.all(promises);
    }
  },
);
